import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import PopoverBody from './body';
import PopoverButton from './button';
import PopoverHeader from './header';
import '@hotmart-org-ca/cosmos/dist/popover';
export const Popover = forwardRef(function Popover({ children, className, position = 'top', autoShow = false, dismissible }, ref) {
    const popoverElement = useRef(null);
    useEffect(function effectAutoShowPopover() {
        if (autoShow && popoverElement.current) {
            popoverElement.current.openPopover();
        }
    }, [autoShow]);
    useImperativeHandle(ref, () => ({
        openPopover() {
            popoverElement.current?.openPopover();
        },
        closePopover() {
            popoverElement.current?.closePopover();
        }
    }));
    return (_jsx("hot-popover", { class: className, position: position, ref: popoverElement, dismissible: dismissible, style: {
            '--popover-max-width': 'none',
            '--popover-width': 'none',
            '--popover-border-width': 'none'
        }, children: children }));
});
export default Object.assign(Popover, {
    Button: PopoverButton,
    Header: PopoverHeader,
    Body: PopoverBody
});
